/**
 * Customer-facing names for the two SIP trunk services.
 *
 * "SRT" is the internal name for the modern service — it stays in endpoints,
 * service types and code, but means nothing to a customer, so every
 * user-visible surface renders these labels instead.
 */
export const SBCAAS_CLASSIC_LABEL = 'SBCaaS';
export const SBCAAS_MODERN_LABEL = 'Cloud SIP Trunks';

/** Dashboard container and platform name covering both services. */
export const CLOUD_SIP_LABEL = 'Cloud SIP';
